(ns app.domain.archiving.model
  (:require #?(:clj [core.util.edn :as edn])
            [app.domain.form.model :as form-model]
            [app.domain.group.model :as group-model]
            [app.domain.workspace.model :as workspace-model]
            [core.db.entity.util :as eu]
            [potpuri.core :as p]))

(defn decode-value [value]
  #?(:clj  (edn/decode value)
     :cljs value))

(defn get-field-value [{:keys [:archiving-field/value]}]
  (decode-value value))


(defn field-has-non-blank-value? [field]
  (-> field get-field-value form-model/is-empty? not))

(defn field-has-some-value [field]
  (when (contains? field :archiving-field/value)
    field))

(defn manual-input-is-visible? [selected-value]
  (= selected-value :archiving/manual-input))

(defn get-values-for-select
  "Used to add 'other option' when displaying the select input"
  [{:archiving-field-schema/keys [possible-values manual-input-config]}]
  (let [possible-values (decode-value possible-values)]
    (if manual-input-config
      (conj possible-values :archiving/manual-input)
      possible-values)))

(defn fields-have-same-schema? [field1 field2]
  (let [get-id #(get-in % [:archiving-field/schema :archiving-field-schema/id])]
    (= (get-id field1)
       (get-id field2))))

(defn find-field-by-schema-id [fields id]
  (p/find-first fields
                #(->> %
                      :archiving-field/schema
                      :archiving-field-schema/id
                      (= id))))

(defn get-value-of-field-by-schema-id [fields schema-id]
  (some-> (find-field-by-schema-id fields schema-id)
          get-field-value))

(defn exclude-the-field? [archiving-fields
                          {{:keys [:archiving-field-schema/condition]} :archiving-field/schema}]
  (let [{:keys [action schema-id value]} (decode-value condition)]
    (if (#{:hide :show} action)
      (let [condition-is-true? (-> archiving-fields
                                   (find-field-by-schema-id schema-id)
                                   :archiving-field/value
                                   decode-value
                                   (= value))]
        (if condition-is-true?
          (= action :hide)
          (= action :show)))
      false)))

(defn filter-archiving-fields [archiving-fields]
  (->> archiving-fields
       (remove (partial exclude-the-field? archiving-fields))
       (sort-by (comp :ordered/order :archiving-field/schema))))

(defn get-archiving-fields
  [archiving]
  (->> archiving
       :entity/_parent
       (filter (eu/is-type-fn :entity.type/archiving-field))
       filter-archiving-fields))

(defn get-archiving-metadata-entities [archiving]
  (filter #(-> % :entity/type (= :entity.type/archiving-metadata))
          (:entity/_parent archiving)))

(def archived-state
  {:entity.type/pre-consultation :pre-consultation.state/archived
   :entity.type/application      :state.application/archived
   :entity.type/execution        :execution.state/archived
   :entity.type/archiving        :archiving.state/archived})

(defn is-archived?
  "Check whether workspace is archived"
  [workspace]
  (let [{phase-state :domain/state
         phase-type  :entity/type} (workspace-model/workspace-target workspace)]
    (= (get archived-state phase-type)
       phase-state)))

(defmethod group-model/get-authority-group :entity.type/archiving
  [app]
  (-> app :entity/parent group-model/get-authority-group))
